/**
 * @file        src/pages/hotel/CorporateUsedCouponList.jsx
 * @description Corporate Hotel → Used Coupon List. Same list as the B2C Hotel
 *              Used Coupon List (UsedCouponList.jsx), fixed to audience=b2b,
 *              instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Hotel menu parity with B2C).
 */
import UsedCouponList from './UsedCouponList';

export default function CorporateUsedCouponList() {
  return (
    <UsedCouponList
      title="Corporate Used Coupon List"
      subtitle="Corporate Hotel · B2B coupons applied to bookings"
      audience="b2b"
    />
  );
}
